<template>
  <div ref="textTitle">
    <p @click="textClicked()" :class="{ 'show-less': showLess }">
      {{ text }}
    </p>
    <div v-if="longText" class="expand-text bold">
      <div v-if="showLess == false" @click="showLess = true">See less</div>
      <div v-if="showLess == true" @click="showLess = false">See more</div>
    </div>
  </div>
</template>

<script>
import bus from "../../bus";

export default {
  data() {
    return {
      longText: false,
      showLess: false,
    };
  },
  methods: {
    isLongTitle: function () {
      this.longText = this.$refs.textTitle ? this.$refs.textTitle.clientHeight > 105 : false;
      if (this.longText) {
        this.showLess = true;
      } else {
        this.showLess = false;
      }
    },
    textClicked: function () {
      this.$emit("textClicked");
    },
    updateMyIdeasEvent: function () {
      bus.$on("updateMyIdeas", () => {
        this.isLongTitle();
      });
    },
  },
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  beforeMount() {
    this.updateMyIdeasEvent();
  },
  mounted() {
    this.isLongTitle();
    window.addEventListener("resize", this.isLongTitle);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.isLongTitle);
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

div p {
  width: calc(100% - 50px + 12px);
  margin: 0px;
  word-wrap: break-word;
  white-space: pre-line;
}

.show-less {
  overflow: hidden;
  max-height: 6em;
}

.expand-text {
  margin-top: 4px;
  font-size: 12px;
  color: theme.$accent-color;
  cursor: pointer;
}
</style>